import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function SupportModal({ isOpen, onClose }) {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError(null);

    try {
      const response = await fetch("https://formsubmit.co/ajax/andrea@feelim.io", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message,
          _subject: "Feelim Support Request",
        }),
      });

      if (response.ok) {
        setSubmitted(true);
        setFormData({ name: "", email: "", message: "" });
      } else {
        setError("Failed to send message. Please try again.");
      }
    } catch (err) {
      setError("Failed to send message. Please try again.");
    } finally {
      setSending(false);
    }
  };

  const handleClose = () => {
    setSubmitted(false);
    setError(null);
    setFormData({ name: "", email: "", message: "" });
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black-900 bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl p-6 w-full max-w-[480px] shadow-xl mx-4">

        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold text-black-800">
            {t("sidebar.support")}
          </h3>
          <button
            onClick={handleClose}
            className="text-black-600 hover:text-black-900 text-xl font-bold p-1"
          >
            ✕
          </button>
        </div>

        {submitted ? (
          /* Success message */
          <div className="flex flex-col items-center py-8 gap-4">
            <div className="text-4xl">✅</div>
            <p className="text-lg font-bold text-black-800 text-center">
              Message sent!
            </p>
            <p className="text-black-600 text-center">
              We'll get back to you as soon as possible.
            </p>
            <button
              onClick={handleClose}
              className="flex flex-1 bg-black-600 hover:bg-black-900 focus:outline-none focus:ring-2 focus:ring-primary-400 text-white text-lg font-bold rounded-lg border-black-600 hover:border-black-900 border-2 items-center justify-center w-full p-2 gap-2 md:text-md md:self-end sm:flex-row sm:items-center sm:flex-1 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {t("buttons.close")}
            </button>
          </div>
        ) : (
          /* Form */
          <div className="flex flex-col gap-4">
            <div>
              <label className="block text-sm font-bold text-black-800 mb-1">
                {t("supportModal.name")}
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Your name"
                className="w-full border border-black-600 rounded-lg px-3 py-2 text-lg focus:outline-none focus:ring-2 focus:ring-primary-400"
              />
            </div>

            <div>
              <label className="block text-sm font-bold text-black-800 mb-1">
                {t("supportModal.email")}
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="your@email.com"
                className="w-full border border-black-600 rounded-lg px-3 py-2 text-lg focus:outline-none focus:ring-2 focus:ring-primary-400"
              />
            </div>

            <div>
              <label className="block text-sm font-bold text-black-800 mb-1">
                {t("supportModal.message")}
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                placeholder="How can we help you?"
                rows={4}
                className="w-full border border-black-600 rounded-lg px-3 py-2 text-lg focus:outline-none focus:ring-2 focus:ring-primary-400 resize-none"
              />
            </div>

            {error && (
              <p className="text-red-600 text-sm">{error}</p>
            )}

            <div className="flex flex-col-reverse sm:flex-row gap-3 sm:justify-end">
              <button
                onClick={handleClose}
                className="flex flex-1 w-full bg-black-0 hover:bg-black-20 focus:outline-none focus:ring-2 focus:ring-primary-400 text-black-800 text-lg font-bold rounded-lg border-black-800 border-2 items-center justify-center p-2 gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {t("buttons.cancel")}
              </button>
              <button
                onClick={handleSubmit}
                disabled={sending || !formData.name || !formData.email || !formData.message}
                className="flex flex-1 bg-black-600 hover:bg-black-900 focus:outline-none focus:ring-2 focus:ring-primary-400 text-white text-lg font-bold rounded-lg border-black-600 hover:border-black-900 border-2 items-center justify-center w-full p-2 gap-2 md:text-md md:self-end sm:flex-row sm:items-center sm:flex-1 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {sending ? `${t("buttons.cancel")}...` : t("buttons.send")}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}